import { groupPolicyEntrypoint } from '@jira/eoc__group-policy/src/groupPolicyEntrypoint.entrypoint.tsx';
import {
	AsyncHorizontalOperationsNav,
	LazyHorizontalOperationsNav,
} from '@jira/navigation-apps__horizontal-nav-jsm-operations-container/src/async.tsx';

import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocGroupPolicyRoute } from '@jira/router-routes__eoc-group-policy-routes/src/eocGroupPolicyRoute.tsx';
import { opsTeamLayout } from '@jira/platform__layouts-ops-team-layout/src/index.tsx';
import { resources as teamDashboardResources } from '@atlassian/eoc-team-dashboard/resources';
import { teamGroupPolicyResource } from '@atlassian/aiops-group-customisation/resources';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const groupPolicyPageEntryPoint = createPageEntryPoint({
	main: groupPolicyEntrypoint,
});

export const eocGroupPolicyRouteEntry: Route = createEntry(eocGroupPolicyRoute, () => ({
	group: 'eoc',
	layout: opsTeamLayout,
	entryPoint() {
		return groupPolicyPageEntryPoint;
	},
	resources: [
		...getNavigationResources(),
		...teamDashboardResources(),
		teamGroupPolicyResource,
		getConsolidationStateResource(),
	],
	navigation: {
		horizontal: AsyncHorizontalOperationsNav,
	},
	forPaint: [LazyHorizontalOperationsNav],
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
